
import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

import { post } from '../../../helpers/api_helper';
import { POST_CHEQUE_ISSUED_ADD_EDIT, POST_CHEQUE_ISSUED_DETAIL, POST_SEARCH, POST_DELETE_SEARCH } from '../../../helpers/url_helper';
import { Date_format } from '../../../helpers/Helper';
import { toast } from 'react-toastify';
import useMounted from '../../../hooks/useMounted';
import Loader from '../../../components/Loader';
import SimpleReactValidator from 'simple-react-validator';
import { useTranslation } from 'react-i18next';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const Setting = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();

    const [isLoader, setLoader] = useState(0);
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({ chequeId: 0, bankId: '', formatId: '', name: '', amount: '', date: '', chequeType: '', chequeNumber: '' });
    const [withoutDatePrint, setWithoutDatePrint] = useState(false);
    const [withoutAmountPrint, setWithoutAmountPrint] = useState(false);
    const simpleValidator = useRef(new SimpleReactValidator());
    const [BankList, SetBankList] = useState([]);
    const [BankFormatList, SetBankFormatList] = useState([]);
    const [, forceUpdate] = useState();

    const [suggestion, setsuggestion] = useState([]);
    const [activeOption, setActiveOption] = useState(-1);
    const [showOptions, setshowOptions] = useState(false);
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 10);

    useMounted(() => {
        async function get_detaile() {
            await get_deatile();
            setLoader(1);
        }
        get_detaile();
    }, [])

    const get_deatile = async () => {
        var res_data = await post(POST_CHEQUE_ISSUED_DETAIL, { chequeId: id });
        if (res_data.status) {
            SetBankList(res_data.data.bankList);
            if (id) {
                // Check if amount is 0 or empty, set withoutAmountPrint and clear amount
                if (!res_data.data.chequeDetail.amount || res_data.data.chequeDetail.amount == 0) {
                    setWithoutAmountPrint(true);
                    res_data.data.chequeDetail.amount = '';
                }

                setInputs(res_data.data.chequeDetail);

                // Check if date is empty, set withoutDatePrint
                if (!res_data.data.chequeDetail.date) {
                    setWithoutDatePrint(true);
                }

                var formatObject = findObjectById(res_data.data.bankList, res_data.data.chequeDetail.bankId, 'bankId');
                if (formatObject) {
                    SetBankFormatList(formatObject.formatList)
                } else {
                    SetBankFormatList([])
                }
            } else if (res_data.data.cheque_format) {

                var formatObject1 = findObjectById(res_data.data.bankList, res_data.data.cheque_format.bankId, 'bankId');
                SetBankFormatList(formatObject1.formatList);

                form_inputs.bankId = res_data.data.cheque_format.bankId;
                form_inputs.formatId = res_data.data.cheque_format.formatId;
                setInputs({ ...form_inputs });
            }

        } else {
            toast.error(res_data.message);
            navigate("/cheque-issued");
        }
    }

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_CHEQUE_ISSUED_ADD_EDIT, form_inputs, {});
            if (res_data.status) {
                toast(res_data.message);
                navigate("/cheque-issued");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // input text change handler
    const handleInputChange = async (event) => {
        if (event.target.name === 'name') {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value.toUpperCase() }));

            if (event.target.value) {
                setActiveOption(-1);
                var res_data = await post(POST_SEARCH, { s: event.target.value });
                if (res_data.status) {
                    setsuggestion(res_data.data.search);
                }
                setshowOptions(true);
            } else {
                setshowOptions(false);
                setActiveOption('');
            }

        } else if (event.target.name === 'bankId') {
            var formatObject = findObjectById(BankList, event.target.value, 'bankId');
            if (formatObject) {
                SetBankFormatList(formatObject.formatList)
            } else {
                SetBankFormatList([])
            }
            form_inputs.bankId = event.target.value;
            form_inputs.formatId = '';
            setInputs({ ...form_inputs });
        } else if (event.target.name === 'date') {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: Date_format(new Date(event.target.value).getTime()) }));
        } else {
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }

    function findObjectById(arr, id, key = "id") {
        if (!Array.isArray(arr)) {
            throw new Error("First argument must be an array.");
        }
        return arr.find(item => parseInt(item[key]) === parseInt(id)) || null;
    }
    
    const select_serch = async (select) => {
        // setSearch(select);
        form_inputs.name = select
        setInputs({ ...form_inputs });
        setshowOptions(false);
        setActiveOption('');
    }

    const onKeyDown = async (e) => {

        if (e.keyCode === 13) {
            e.preventDefault();
            if (showOptions && activeOption >= 0) {
                form_inputs.name = suggestion[activeOption].name
                setInputs({ ...form_inputs });

                setshowOptions(false);
                setActiveOption('');
            }
        } else if (e.keyCode === 38) {
            e.preventDefault();
            if (activeOption === 0) {
                return;
            }
            setActiveOption(parseInt(activeOption) - 1)
        } else if (e.keyCode === 40) {
            e.preventDefault();
            if (activeOption === suggestion.length - 1) {
                return;
            }
            setActiveOption(parseInt(activeOption) + 1)
        }
    };

    const delete_search = async (name) => {
        var res_data = await post(POST_DELETE_SEARCH, { s: name });
        if (!res_data.status) {
            toast.error(res_data.message);
        }
        const filtered = suggestion.filter(item => item.name !== name);
        setsuggestion(filtered);
    }

    return (
        <>
            {!isLoader && <Loader />}
            <div className='row'>
                <div className="col-md-12">
                    <div className="card mb-4">
                        <h5 className="card-header">{t('chequeIssued.ticketList.chequeIssue')}</h5>
                        <div className="card-body">
                            <form className="av-invalid" onSubmit={handleSubmit}>
                                <div className='row'>
                                    <div className='mb-3 col-sm-6 col-md-4'>
                                        <label className="form-label text-capitalize">{t('chequeIssued.form.selectBank')} *</label>
                                        <select name="bankId" value={form_inputs.bankId} onChange={handleInputChange} className="form-control">
                                            <option value="">{t('chequeIssued.form.selectBank')}</option>
                                            {BankList && BankList.map((value) => {
                                                return (
                                                    <option value={value.bankId} key={value.bankId}>{value.bankName}</option>
                                                )
                                            })}
                                        </select>
                                        {simpleValidator.current.message('', form_inputs.bankId, 'required', { messages: { required: t('chequeIssued.formError.selectBankRequired') } })}
                                    </div>
                                    <div className='mb-3 col-sm-6 col-md-4'>
                                        <label className="form-label text-capitalize">{t('chequeIssued.form.selectFormat')} *</label>
                                        <select name="formatId" value={form_inputs.formatId} onChange={handleInputChange} className="form-control">
                                            <option value="">{t('chequeIssued.form.selectFormat')}</option>
                                            {BankFormatList && BankFormatList.map((value) => {
                                                return (
                                                    <option value={value.formatId} key={value.formatId}>{value.formatName}</option>
                                                )
                                            })}
                                        </select>
                                        {simpleValidator.current.message('', form_inputs.formatId, 'required', { messages: { required: t('chequeIssued.formError.selectFormatRequired') } })}
                                    </div>
                                    <div className='mb-3 col-sm-6 col-md-4'>
                                        <label className="form-label text-capitalize">{t('chequeIssued.form.date')} {!withoutDatePrint && '*'}</label>
                                        <DatePicker name='date' className='form-control'
                                            selected={(form_inputs.date) ? new Date(form_inputs.date) : ''} onChange={(date) => { handleInputChange({ target: { name: 'date', value: date } }) }}
                                            placeholderText={t('chequeIssued.form.date')}
                                            dateFormat="dd/MM/yyyy"
                                            minDate={minDate}
                                            onKeyDown={(e) => e.preventDefault()}
                                            autoComplete="off"
                                            disabled={withoutDatePrint}
                                        />
                                        {!withoutDatePrint && simpleValidator.current.message('', form_inputs.date, 'required', { messages: { required: t('chequeIssued.formError.dateRequired') } })}
                                        <div className="form-check mt-2">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="withoutDatePrint"
                                                checked={withoutDatePrint}
                                                onChange={(e) => {
                                                    setWithoutDatePrint(e.target.checked);
                                                    if (e.target.checked) {
                                                        setInputs({ ...form_inputs, date: '' });
                                                    }
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="withoutDatePrint">{t('chequeIssued.form.withoutDatePrint')}</label>
                                        </div>
                                    </div>
                                    <div className='mb-3 col-sm-6 col-md-4'>
                                        <div className='search_box'>
                                            <label className="form-label text-capitalize">{t('chequeIssued.form.payName')} *</label>
                                            <input name="name" onBlur={() => { setshowOptions(false); setActiveOption(''); }} value={form_inputs.name} onKeyDown={onKeyDown} onChange={handleInputChange} className="form-control" type="text" autoComplete="off" />
                                            {showOptions && suggestion.length > 0 && <div className="suggestion">
                                                <ul className="options">
                                                    {suggestion.map((optionName, index) => {
                                                        var className = (index === activeOption) ? 'active' : '';
                                                        return (
                                                            <li className={className} key={index} onMouseDown={() => { select_serch(optionName.name) }}>{optionName.name} <i onMouseDown={(e) => { e.stopPropagation(); e.preventDefault(); delete_search(optionName.name) }} className="delete bx bx-trash-alt align-middle"></i></li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>}
                                            {simpleValidator.current.message('', form_inputs.name, 'required', { messages: { required: t('chequeIssued.formError.payNameRequired') } })}
                                        </div>
                                    </div>

                                    <div className='mb-3 col-sm-6 col-md-4'>
                                        <label className="form-label text-capitalize">{t('chequeIssued.form.amount')} {!withoutAmountPrint && '*'}</label>
                                        <input name="amount" value={form_inputs.amount} onChange={handleInputChange} className="form-control" type="text" autoComplete="off" maxLength={9} disabled={withoutAmountPrint} />
                                        {!withoutAmountPrint && simpleValidator.current.message('', form_inputs.amount, 'required|numeric', {
                                            messages: {
                                                required: t('chequeIssued.formError.amountRequired'),
                                                numeric: t('chequeIssued.formError.amountNumeric'),
                                            }
                                        })}
                                        <div className="form-check mt-2">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="withoutAmountPrint"
                                                checked={withoutAmountPrint}
                                                onChange={(e) => {
                                                    setWithoutAmountPrint(e.target.checked);
                                                    if (e.target.checked) {
                                                        setInputs({ ...form_inputs, amount: '' });
                                                    }
                                                }}
                                            />
                                            <label className="form-check-label" htmlFor="withoutAmountPrint">{t('chequeIssued.form.withoutAmountPrint')}</label>
                                        </div>
                                    </div>
                                    <div className="mb-3 col-sm-6 col-md-4">
                                        <label for="email" className="form-label text-capitalize">{t('chequeIssued.form.selectChequeType')} *</label>
                                        <select name="chequeType" value={form_inputs.chequeType} onChange={handleInputChange} className="form-control">
                                            <option value="">{t('chequeIssued.form.selectChequeType')}</option>
                                            <option value="A/C Payee">A/C Payee</option>
                                            <option value="Cancelled">Cancelled</option>
                                            <option value="Crossed Cheque">Crossed Cheque</option>
                                            <option value="Bearer">Bearer</option>
                                        </select>
                                        {simpleValidator.current.message('', form_inputs.chequeType, 'required', { messages: { required: t('chequeIssued.formError.chequeTypeRequired') } })}
                                    </div>
                                    <div className='mb-3 col-sm-6 col-md-4'>
                                        <label className="form-label text-capitalize">{t('chequeIssued.form.chequeNumber')}</label>
                                        <input name="chequeNumber" value={form_inputs.chequeNumber} onChange={handleInputChange} className="form-control" type="text" autoComplete="off" />
                                    </div>
                                </div>


                                <div className='text-center mt-3'>
                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('Save')}
                                    </button>
                                    <Link to="/cheque-issued" className="btn btn-danger ms-3"> {t('cancel')}</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Setting;